// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';
import {
    type Country
} from './countryModels';

export const countryApi = createApi({
    reducerPath: 'countryApi',
    baseQuery: baseQuery('public/pays'),
    endpoints: (builder) => {
        return {
            getCountry: builder.query<Country[], string>({
                query: (lang) => {
                    return {
                        url: 'liste',
                        method: 'get',
                        params: {
                            lang
                        }
                    };
                },
            }),
            getActiveCountries: builder.query<Country[], string>({
                query: (lang) => {
                    return {
                        url: 'actifs',
                        method: 'get',
                        params: {
                            lang
                        }
                    };
                },
            }),
        };
    },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCountryQuery, useGetActiveCountriesQuery } = countryApi;
